// extracted by mini-css-extract-plugin
module.exports = {"bidOfferContainer":"BidOfferCell_bidOfferContainer__pAH7s","bidOfferLabel":"BidOfferCell_bidOfferLabel__8iAi0"};